import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { Transforms } from 'vendor/slate'
import { v4 as uuidv4 } from 'uuid'

const insertImage = (editor, path, options) => {
  const image = {
    type: ELEMENT_TYPES.image,
    url: options.url,
    caption: '',
    size: 100,
    children: [{ uuid: uuidv4(), text: '', parent: { type: ELEMENT_TYPES.image } }]
  }

  Transforms.insertNodes(editor, image, { at: path })
}

export { insertImage }
